<template>
  <section class="vacancies" id="vacancies">
    <div class="container">
      <h1 class="block-title">
        {{portalData.VacanciesList.vacancies[lang]}}
      </h1>
      <div :class="{
        'nice-select': true,
        'vacancies__catsSelect': true,
        open: this.selectVisible
      }" tabindex="0"
         @click="toggleSelect()"
      >
        <span class="current"> {{ currentVacancyType.charAt(0).toUpperCase() + currentVacancyType.slice(1).toLowerCase()}} {{ getVacancyTypeNumber(currentVacancyType) }}</span>
        <ul class="list">
          <li @click.stop="selectVacancyType('all')"
              :class="{
                option: true,
                selected: currentVacancyType === 'all',
                focused: currentVacancyType === 'all',
              }"
          > {{ 'All' }} {{ totalVacancies }}</li>
          <li v-for="item in vacancyTypes" @click.stop="selectVacancyType(item.type)"
              :class="{
                option: true,
                selected: currentVacancyType === item.type,
                focused: currentVacancyType === item.type,
              }"
          >{{ item.type .charAt(0).toUpperCase() + item.type .slice(1).toLowerCase()}} {{ item.number }}</li>
        </ul>
        </div>
      <div class="vacancies__catsList">
        <a   href="#"
             data-cat="all"
             @click="selectVacancyType('all')"
             @click.stop
             :class="{
               'vacancies__catsList-item': true,
               active: currentVacancyType === 'all'
             }">
          {{ 'All' }} {{ totalVacancies }}
        </a>
        <a
            v-for="item in vacancyTypes"
            :key="item.type"
            :data-cat="item.type"
            :class="{
               'vacancies__catsList-item': true,
               active: currentVacancyType === item.type
             }"
            @click="selectVacancyType(item.type)"
            href="#">
          <img class="vacancies__catsList-img" :src="item.img">
          {{ item.type .charAt(0).toUpperCase() + item.type .slice(1).toLowerCase()}} {{ item.number }}
        </a>
      </div>
      <div class="vacancies__list">
        <a v-for="vacancy in currentVacancies" :href="'vacancies/' + encodeURIComponent(vacancy.name)" class="vacancies__list-item active" data-cat="programming">
          <div class="vacancies__list-icon">
            <span class="media-wrapper">
              <img class="img" :src="vacancy.image" />
            </span>
          </div>
          <div class="vacancies__list-descr">
            <div class="vacancies__list-title">
              {{vacancy.name}}
            </div>
            <div class="vacancies__list-text">
              <div class="vacancies__list-geo">
                <img :src="require('./../../assets/icon-geo.png')" alt="">
              </div>
              <span>{{vacancy.description}}</span>
            </div>
          </div>
          <div class="vacancies__list-arrow">
            <img :src="require('./../../assets/arrow-to-right.png')" alt="">
          </div>
        </a>
      </div>
      <a href="mailto:job@labsystech.ru" class="vacancies__email">
        job@labsystech.ru
      </a>
    </div>
  </section>
</template>

<script>
import portalData from "../../portal.json";
export default {
  name: "VacanciesList",
  data() {
    return {
      portalData: portalData,
      currentVacancyType: "all",
      selectVisible: false
    }
  },
  computed: {
    lang() {
      return this.language;
    },
    vacancies() {
      return this.portalData.VacanciesList.vacancies_list.map((vacancy) => {
        const vacancyCopy = {...vacancy};
        vacancyCopy.description = vacancy.description[this.lang];
        vacancyCopy.image =  require(`./../../assets/${vacancy.image ? vacancy.image : "vacancies/icon-" + vacancy.type + ".png"}`);
        return vacancyCopy;
      })
    },
    currentVacancies() {
      const result = [];
      for (const vacancy of this.vacancies) {
        if (vacancy.type === this.currentVacancyType || this.currentVacancyType === "all") {
          result.push(vacancy);
        }
      }
      return result;
    },
    vacancyTypes() {
      const types = {};
      for (let i = 0; i < this.vacancies.length; i++) {
        if (types[this.vacancies[i].type] === undefined) {
          types[this.vacancies[i].type] = 0;
        }
        ++types[this.vacancies[i].type];
      }
      return Object.keys(types).map(type => {
        return {
          type: type,
          number: types[type],
          img: require(`./../../assets/vacancies/icon-${type}.png`)
        };
      });
    },
    totalVacancies() {
      return this.vacancyTypes.reduce((sum, item) => sum + item.number, 0);
    }
  },
  methods: {
    selectVacancyType(vacancyType) {
      this.currentVacancyType = vacancyType;
      this.toggleSelect(false);
    },
    getVacancyTypeNumber(vacancyType) {
      let result = this.totalVacancies;
      for (let i = 0; i < this.vacancyTypes.length; i++) {
        if (this.vacancyTypes[i].type === vacancyType) {
          result = this.vacancyTypes[i].number;
          break;
        }
      }
      return result;
    },
    toggleSelect(visible) {
      visible = visible === undefined ? !this.selectVisible : visible;
      this.selectVisible = visible;
    }
  }
}
</script>

<style scoped>
.vacancies {
  padding: 80px 0 0 0;
}
.vacancies__catsList {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  margin-top: 24px;
}
.vacancies__catsList-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 30px 14px 20px;
  border-radius: 50px;
  background: #e3e3e5;
  font-size: 20px;
  font-family: 'Marvin', sans-serif;
  flex-grow: .2;
  text-align: center;
  transition: .3s;
  user-select: none;
  text-decoration: none;
  color: #424243;
  --hover-bg: #16a6ff;
  font-weight: bold;
}
.vacancies__catsList-img {
  display: inline-block;
  width: 32px;
  height: 32px;
  object-fit: contain;
}
.vacancies__catsList-item[data-cat="art"] { --hover-bg: #de7eec; }
.vacancies__catsList-item[data-cat="programming"] { --hover-bg: #907eec; }
.vacancies__catsList-item[data-cat="qa"] { --hover-bg: #04c9b4; }
.vacancies__catsList-item[data-cat="analytics"] { --hover-bg: #ff6884; }
.vacancies__catsList-item[data-cat="game-design"] { --hover-bg: #64bcf4; }
.vacancies__catsList-item.active {
  pointer-events: none;
  background: var(--hover-bg);
  color: #fff;
}
.vacancies__list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 1160px;
  width: 100%;
  margin: 35px auto 0;
}
.vacancies__list-item {
  align-items: center;
  height: 52px;
  width: 100%;
  background: #e3e3e5;
  border-radius: 16px;
  padding-right: 95px;
  overflow: hidden;
  display: flex;
  text-decoration: none;
}
.vacancies__list-item {
  display: none;
}
.vacancies__list-item.active {
  display: flex;
}
.vacancies__list-title {
  margin-left: 26px;
  font-weight: bold;
  max-width: 300px;
  font-size: 20px;
  align-items: center;
  color: #424243;
  height: 100%;
}
.vacancies__list-title,
.vacancies__list-text span {
  font-size: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
}
.vacancies__list-icon {
  width: 50px;
  border-radius: 16px;
  overflow: hidden;
}
.vacancies__list-geo {
  width: 16px;
  min-width: 16px;
  margin: auto 20px auto 30px;
}
.vacancies__list-geo img {
  width: 100%;
}
.vacancies__list-text {
  color: #787878;
  display: flex;
}
.vacancies__list-text span {
  max-width: 300px;
}
.vacancies__list-descr {
  display: flex;
  align-items: center;
}
.vacancies__list-arrow {
  width: 60px;
  height: 35px;
  background: #16a6ff;
  border-radius: 100px;
  display: flex;
  margin-left: auto;
  transition: .3s;
}
.vacancies__list-arrow img {
  width: 30px;
  margin: auto;
}
.vacancies__email {
  margin: 50px auto 0;
  text-align: center;
  display: block;
  font-size: 22px;
  color: #5d5d60;
}
.media-wrapper {
  display: block;
  position: relative;
  padding-bottom: 100%;
}
.img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.vacancies__catsSelect {
  margin-top: 20px;
  border: 0;
  padding: 0 5px 10px;
  border-bottom: 1px solid #a0a0a1;
  border-radius: 0;
  height: 38px;
  font-size: 14px;
  font-family: 'Marvin', sans-serif;
  display: none;
  margin-bottom: 20px;
}

.vacancies__catsList {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  margin-top: 24px;
}
.nice-select {
  -webkit-tap-highlight-color: transparent;
  background-color: #fff;
  border-radius: 5px;
  border: solid 1px #e8e8e8;
  box-sizing: border-box;
  clear: both;
  cursor: pointer;
  float: left;
  font-family: inherit;
  font-size: 14px;
  font-weight: normal;
  height: 42px;
  line-height: 40px;
  outline: none;
  padding-left: 18px;
  padding-right: 30px;
  position: relative;
  text-align: left !important;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  width: auto; }
.nice-select:hover {
  border-color: #dbdbdb; }
.nice-select:active, .nice-select.open, .nice-select:focus {
  border-color: #999; }
.nice-select:after {
  content: "";
  display: block;
  position: absolute;
  right: 16px;
  top: 50%;
  width: 16px;
  height: 16px;
  background-image: url('./../../assets/arrow-to-bottom.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: none;
  transform: translateY(-50%);
  transition: transform 0.2s;
}
.nice-select.open:after {
  transform: translateY(-50%) rotate(-180deg);
}
.nice-select.open .list {
  opacity: 1;
  pointer-events: auto;
  -webkit-transform: scale(1) translateY(0);
  -ms-transform: scale(1) translateY(0);
  transform: scale(1) translateY(0); }
.nice-select.right .list {
  left: auto;
  right: 0; }
.nice-select .list {
  background-color: #f6f6f6;
  border-radius: 5px;
  box-sizing: border-box;
  margin-top: 4px;
  opacity: 0;
  overflow: hidden;
  padding: 0;
  pointer-events: none;
  position: absolute;
  top: 100%;
  left: 0;
  -webkit-transform-origin: 50% 0;
  -ms-transform-origin: 50% 0;
  transform-origin: 50% 0;
  -webkit-transform: scale(0.75) translateY(-21px);
  -ms-transform: scale(0.75) translateY(-21px);
  transform: scale(0.75) translateY(-21px);
  -webkit-transition: all 0.2s cubic-bezier(0.5, 0, 0, 1.25), opacity 0.15s ease-out;
  transition: all 0.2s cubic-bezier(0.5, 0, 0, 1.25), opacity 0.15s ease-out;
  z-index: 9; }
.nice-select .list:hover .option:not(:hover) {
  background-color: transparent !important; }
.nice-select .option {
  cursor: pointer;
  font-weight: 400;
  line-height: 40px;
  list-style: none;
  min-height: 40px;
  outline: none;
  padding-left: 18px;
  padding-right: 29px;
  text-align: left;
  -webkit-transition: all 0.2s;
  transition: all 0.2s; }
.nice-select .option:hover, .nice-select .option.focus, .nice-select .option.selected.focus {
  background-color: #f6f6f6; }
.nice-select .option.selected {
  font-weight: bold; }
.nice-select .list {
  width: 100%;
}

.no-csspointerevents .nice-select .list {
  display: none; }

.no-csspointerevents .nice-select.open .list {
  display: block; }

.current, .option {
  color: black;
  font-size: 20px;
  font-weight: bolder;
}

@media (max-width: 450px) {
  .vacancies__list-item {
    padding-right: 10px!important;
  }
}

@media (max-width: 800px) {
  .vacancies__catsList {
    display: none;
  }
  .vacancies__catsSelect {
    display: block;
    width: 100%;
    margin-top: 20px;
    border: 0;
    padding: 0 5px 10px;
    border-bottom: 1px solid #a0a0a1;
    border-radius: 0;
    height: 38px;
    font-size: 14px;
    font-family: 'Marvin', sans-serif;
  }
  .vacancies__list-item {
    padding-right: 40px;
    min-width: 360px;
  }
  .vacancies__list-title {
    margin-left: 15px;
    font-size: 20px;
  }
}

@media (max-width: 1000px) {
  .vacancies__list-descr {
    flex-direction: column;
    align-items: flex-start;
  }
  .vacancies__list-title, .vacancies__list-text span  {
    font-size: 14px;
  }
  .vacancies__list-text {
    align-items: flex-start;
  }
  .vacancies__list-geo {
    min-width: 8px;
    width: 12px;
    margin: auto 5px auto 15px;
  }
  .vacancies__list-text span  {
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

</style>